import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IApplicationState, RootActionCreators } from '../../store';
import { FetchState } from '../../entities/FetchState';
import WarningIcon from '@material-ui/icons/Warning';
import { IconWithTooltip } from '../atoms/IconWithTooltip';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(1),
  },
}));

// Props from State
interface IPropsFromState {
  hasValidVaphToken: boolean;
  companyInfoLoaded: boolean;
}

const mapStateToProps = (state: IApplicationState): IPropsFromState => {
  const companyInfo = state.companies.companyInfo.CompanyInfo;
  return {
    hasValidVaphToken: companyInfo.state === FetchState.Success 
      ? companyInfo.data.hasValidVaphJwtToken 
      : true, // Default to true if not loaded yet to avoid showing warning prematurely
    companyInfoLoaded: companyInfo.state === FetchState.Success,
  };
};

// Props from Dispatch
interface IPropsFromDispatch {
  loadCompanyInfo: () => void;
}

const mapDispatchToProps = (dispatch: Dispatch): IPropsFromDispatch => ({
  loadCompanyInfo: () => dispatch(RootActionCreators.Companies.companyInfo.FetchData()),
});

// Component Props
interface IProps {}

// All Props
export type AllProps = IProps & IPropsFromState & IPropsFromDispatch;

export const SettingsWarningsComponent: React.FC<AllProps> = (props) => {
  const classes = useStyles();
  const { t } = useTranslation('companies');

  // Load company info on mount if not already loaded
  useEffect(() => {
    if (!props.companyInfoLoaded) {
      props.loadCompanyInfo();
    }
  }, [props.companyInfoLoaded, props.loadCompanyInfo]);

  // Build array of warning messages
  const warnings: string[] = [];
  
  if (!props.hasValidVaphToken) {
    warnings.push(t('warningInvalidToken'));
  }

  // If no warnings, don't show anything
  if (warnings.length === 0) {
    return null;
  }

  // Join multiple warnings with line breaks
  const tooltipText = warnings.join('\n');

  return (
    <div className={classes.root}>
      <IconWithTooltip 
        icon={<WarningIcon color="secondary" />} 
        tooltipText={tooltipText}
        placement="bottom"
      />
    </div>
  );
};

// Export connected component
export const SettingsWarnings = connect<IPropsFromState, IPropsFromDispatch, IProps, IApplicationState>(
  mapStateToProps,
  mapDispatchToProps
)(SettingsWarningsComponent);

export default SettingsWarnings;

